export { default } from './view'
